import { render, staticRenderFns } from "./bonusPolicy.vue?vue&type=template&id=37e90f89&scoped=true&"
import script from "./bonusPolicy.vue?vue&type=script&lang=js&"
export * from "./bonusPolicy.vue?vue&type=script&lang=js&"
import style0 from "./bonusPolicy.vue?vue&type=style&index=0&id=37e90f89&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e90f89",
  null
  
)

export default component.exports